import { useCallback, useState } from 'react';

import { isEqual } from 'lodash';
import { XIcon } from 'lucide-react';
import { DefaultPopover } from 'twyne-new.ui'

import { useCraftProp } from '@/components/builder/utils';

import ColorPreview from './ColorPreview';
import PaletteColors from './Palette';

export default function ColorPickerProperty({ name = '', side = 'left', removePopover = false, components = ['preview', 'input'], onChange, disabled, ...props }) {
  const { value, setValue } = useCraftProp(name)
  const [open, setOpen] = useState(false)

  const handleChange = useCallback(newValue => {
    if (onChange) {
      return onChange(newValue)
    }

    if (!isEqual(newValue, value)) {
      setValue(newValue)
    }
  }, [setValue, value, onChange])

  return <>
    <div onClick={() => !disabled && setOpen(true)}>
      <ColorPreview variant='accent' disabled={disabled} value={value} onChange={onChange || handleChange} components={components} {...props} />
    </div>
    <DefaultPopover
      trigger={<span className='absolute'></span>}
      triggerProps={{ asChild: true }}
      contentProps={{ align: 'center', side, className: 'relative' }}
      wrapperProps={{ open: open && !removePopover, onOpenChange: setOpen }}
    >
      <XIcon size='16' className='absolute right-2 top-2 cursor-pointer' onClick={() => !disabled && setOpen(false)} />
      <PaletteColors value={value} onChange={handleChange} />
    </DefaultPopover>
  </>
}
